module.exports = __webpack_public_path__ + "img/bottom-text-th.fe671dfa.png";